// Static placeholder content for Little Gurus Academy

export const SITE = {
  name: "Little Gurus Academy",
  tagline: "Where little minds grow big",
  email: "littlegurusacademy@gmail.com",
  grievanceEmail: "littlegurusacademy@gmail.com",
  hours: "Mon–Fri, 7:00 PM – 9:00 PM IST",
  mode: "100% Online · Mobile App · YouTube · Instagram",
  address: "Gurgaon, Haryana 122004, India",
  dataFiduciary: "Little Gurus Academy",
  instagram: "https://www.instagram.com/littlegurus_in?igsh=bzk5bmVpMXVoY243",
  youtube: "https://youtube.com/@littlegurusacademy?feature=shared",
};

export const TRUST_BADGES = [
  { icon: "ShieldCheck", label: "Certified Teachers" },
  { icon: "Lock", label: "Safe & Secure" },
  { icon: "Users", label: "Small Live Classes" },
  { icon: "Sparkles", label: "Joyful Learning" },
];

export const WHY_US = [
  {
    icon: "Puzzle",
    title: "Play-Based Learning",
    text: "Games, songs and stories that make learning feel like recess. Kids leave class smiling and asking for more.",
    color: "orange",
  },
  {
    icon: "GraduationCap",
    title: "Certified Educators",
    text: "Hand-picked early-childhood and subject-matter teachers, trained to make online classes feel warm and personal.",
    color: "sky",
  },
  {
    icon: "Heart",
    title: "Nurturing Environment",
    text: "Tiny class sizes mean every guru knows your child by name — their favorite color, their wins, their wobbles.",
    color: "rose",
  },
  {
    icon: "Sprout",
    title: "Holistic Development",
    text: "Beyond ABCs and 123s — confidence, curiosity, kindness and creativity are built into every single lesson.",
    color: "emerald",
  },
];

export const PROGRAMS = [
  {
    id: "tiny-tots",
    age: "Ages 2–4",
    name: "Tiny Tots",
    accent: "emerald",
    image: "https://images.unsplash.com/photo-1495654794940-1c0cd2aeedc1?auto=format&fit=crop&w=800&q=80",
    blurb: "A gentle first taste of school, from the safety of your living room.",
    learn: [
      "Phonics, colors, shapes & numbers through play",
      "Action songs, story-time and finger-puppet shows",
      "Tiny motor-skill activities parents can join in",
    ],
    schedule: "Mon, Wed, Fri · 25-min live sessions",
  },
  {
    id: "early-learners",
    age: "Ages 4–6",
    name: "Early Learners",
    accent: "sky",
    image: "https://images.pexels.com/photos/7548729/pexels-photo-7548729.jpeg?auto=compress&w=800",
    blurb: "Kindergarten-prep that turns shy kids into curious little explorers.",
    learn: [
      "Reading readiness & sight-word fluency",
      "Number sense, patterns and gentle problem-solving",
      "Show-and-tell, drawing, music & mindfulness",
    ],
    schedule: "Mon–Fri · 35-min live sessions",
  },
  {
    id: "primary-prep",
    age: "Ages 6–8",
    name: "Primary Prep",
    accent: "orange",
    image: "https://images.unsplash.com/photo-1623076189461-f7706b741c04?auto=format&fit=crop&w=800&q=80",
    blurb: "A confident jump-start into Grades 1–2 — reading, writing & wondering.",
    learn: [
      "Guided reading & creative writing journals",
      "Maths foundations: addition, subtraction & word problems",
      "Curiosity science labs and weekly mini-projects",
    ],
    schedule: "Mon–Fri · 45-min live sessions",
  },
  {
    id: "after-school",
    age: "Ages 8–10",
    name: "After-School Tutoring",
    accent: "amber",
    image: "https://images.pexels.com/photos/8430234/pexels-photo-8430234.jpeg?auto=compress&w=800",
    blurb: "Homework help, exam prep and big-kid confidence — all in one cozy class.",
    learn: [
      "Subject support: English, Maths, EVS & Science",
      "Study habits, time-boxing and exam strategies",
      "Public-speaking, debates & weekend hobby clubs",
    ],
    schedule: "Mon–Fri · 60-min live sessions + recordings",
  },
];

export const TEAM = [
  {
    name: "Aanya Mehra",
    role: "Founder & Head Guru",
    bio: "10+ years in early-childhood ed. Mom of two. Believes every child is a tiny genius waiting to bloom.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Rohan Iyer",
    role: "Lead Teacher · Primary",
    bio: "Maths magician. Turns ‘I hate sums’ into ‘one more, please!’ in about three classes flat.",
    image: "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Priya Kapoor",
    role: "Early Years Specialist",
    bio: "Phonics whisperer. Has more puppet voices than your favorite cartoon. Trained in Montessori methods.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Karthik Rao",
    role: "Science & Curiosity Lead",
    bio: "Ex-engineer, full-time storyteller. Builds at-home experiments that make parents go ‘woah’.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80",
  },
];

export const TESTIMONIALS = [
  {
    name: "Shruti & Aarav (age 5)",
    text: "Aarav literally sets up his own laptop now. He calls his teacher ‘best friend Priya didi’. We've never seen him this excited about learning.",
    location: "Bengaluru",
  },
  {
    name: "Faisal & Zara (age 7)",
    text: "After-school class is the only screen-time I don't feel guilty about. Her reading has shot up two grade levels in four months.",
    location: "Delhi",
  },
  {
    name: "Meera & Kabir (age 3)",
    text: "Tiny Tots is gentle, calm and oh-so-warm. The teachers actually know my child. That's rare for an online program.",
    location: "Pune",
  },
  {
    name: "Anand & twins (age 6)",
    text: "Small class sizes are the real deal. Both my kids get personal attention every single day. Honestly worth twice what we pay.",
    location: "Hyderabad",
  },
];

export const STATS = [
  { value: 1200, suffix: "+", label: "Happy little gurus" },
  { value: 96, suffix: "%", label: "Parents recommend us" },
  { value: 35, suffix: "+", label: "Certified teachers" },
  { value: 5, suffix: " yrs", label: "Of joyful learning" },
];

export const DAY_TIMELINE = [
  { time: "Hello!", title: "Circle time", text: "Songs, a giggle, today's plan — and one tiny mindfulness breath." },
  { time: "Discover", title: "Core lesson", text: "Live, interactive teaching with whiteboards, puppets & tiny challenges." },
  { time: "Wiggle", title: "Movement break", text: "Stretch, dance or a silly Simon-says — because brains need bodies." },
  { time: "Create", title: "Activity time", text: "Drawing, writing, building — making the lesson stick with little hands." },
  { time: "Share", title: "Show & tell", text: "Kids show their work, get gentle claps, and high-five their gurus." },
];

export const FEES = [
  { program: "Tiny Tots (2–4)", sessions: "3 / week · 25 min", monthly: "₹1,000", quarterly: "₹2,700" },
  { program: "Early Learners (4–6)", sessions: "5 / week · 35 min", monthly: "₹1,000", quarterly: "₹2,700" },
  { program: "Primary Prep (6–8)", sessions: "5 / week · 45 min", monthly: "₹1,000", quarterly: "₹2,700" },
  { program: "After-School (8–10)", sessions: "5 / week · 60 min", monthly: "₹1,000", quarterly: "₹2,700" },
];

export const FAQS = [
  {
    q: "What devices do we need?",
    a: "Just a tablet, laptop or phone with a stable internet connection. We have a free Little Gurus mobile app for the easiest experience.",
  },
  {
    q: "What are the class timings?",
    a: "Live classes run Mon–Fri, 7:00 PM – 9:00 PM IST. All sessions are also recorded so kids can revisit lessons any time.",
  },
  {
    q: "How big are the classes?",
    a: "We cap every live class at 8 children, so every guru knows your child by name and learning pace.",
  },
  {
    q: "Is there a free trial?",
    a: "Yes! We invite every family to a free 1-on-1 tour & demo class before you commit to anything.",
  },
  {
    q: "Is my child too young or too old?",
    a: "We currently support ages 2 to 10. If you're unsure which program fits, hop on a free tour — we'll guide you honestly.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Absolutely. Plans are month-to-month with no lock-ins. Pause or stop with a simple email — no awkward calls.",
  },
];

export const GALLERY_IMAGES = [
  "https://images.pexels.com/photos/7548729/pexels-photo-7548729.jpeg?auto=compress&w=900",
  "https://images.unsplash.com/photo-1495654794940-1c0cd2aeedc1?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1623076189461-f7706b741c04?auto=format&fit=crop&w=900&q=80",
  "https://images.pexels.com/photos/8430234/pexels-photo-8430234.jpeg?auto=compress&w=900",
  "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1588075592446-265fd1e6e76f?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1597392580976-5ec0d04f9b6c?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1587653263995-422546a7a569?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1604881991720-f91add269bed?auto=format&fit=crop&w=900&q=80",
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/programs", label: "Programs" },
  { to: "/admissions", label: "Admissions" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];
